import { FC } from 'react'

import { Button } from '@trustycars/genie-ui/components'

import { header } from '$blocks/common/auth.css'
import ExtraIcon from '$icons/ExtraIcon'
import { authenticatorAppName } from '$constants/texts'

import useCarroIDApproval from '$actions/useMFABlock/useCarroIDApproval'

import {
  title as titleStyle,
  description as descriptionStyle,
  icon,
  container,
  btn,
  iconLoading
} from './styles.css'

export type CarroIDApprovalBlockProps = ReturnType<typeof useCarroIDApproval>

export const CarroIDApprovalBlock: FC<CarroIDApprovalBlockProps> = ({
  isDenied,
  reChallenge,
  errorMsg,
  isAnyLoading
}) => {
  const waitingHead = () => (
    <>
      <ExtraIcon name="pin-loader" className={iconLoading} />

      <header className={header}>
        <h2 className={titleStyle}>
          Waiting approval from
          <br />
          {authenticatorAppName}
        </h2>
      </header>
    </>
  )

  const deniedHead = () => (
    <>
      <ExtraIcon name="circular-cross" className={icon} />

      <header className={header}>
        <h2 className={titleStyle}>
          {errorMsg ? (
            errorMsg
          ) : (
            <>
              Denied request from
              <br />
              {authenticatorAppName}
            </>
          )}
        </h2>

        <p className={descriptionStyle}>Want to request again?</p>
      </header>

      <Button
        styleVariants={{ size: 'small', kind: 'primary', type: 'text' }}
        onClick={reChallenge}
        disabled={isAnyLoading}
        className={btn}
      >
        Try again
      </Button>
    </>
  )

  return (
    <div
      className={container}
      style={{ cursor: isDenied ? 'auto' : 'progress' }}
    >
      {isDenied ? deniedHead() : waitingHead()}
    </div>
  )
}

export default CarroIDApprovalBlock
